import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { AuthShell } from "@/components/AuthShell";

export default function Login() {
  const { user, login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try { await login("/auth/login", form); } catch (e2) { setErr(formatErr(e2)); } finally { setBusy(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <AuthShell title="Sign in" subtitle="Use the email and password given by your admin">
      <form onSubmit={submit} data-testid="auth-card" className="space-y-5">
        <div className="space-y-1.5">
          <Label>Email</Label>
          <Input data-testid="auth-email-input" type="email" required value={form.email} onChange={set("email")} />
        </div>
        <div className="space-y-1.5">
          <div className="flex justify-between items-center">
            <Label>Password</Label>
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-sky-700 hover:underline">Forgot password?</Link>
          </div>
          <Input data-testid="auth-password-input" type="password" required value={form.password} onChange={set("password")} />
        </div>
        {err && <p data-testid="auth-error" className="text-sm text-red-600">{err}</p>}
        <Button data-testid="jwt-login-submit" disabled={busy} className="w-full h-11 bg-sky-600 hover:bg-sky-700">
          {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Sign in
        </Button>
      </form>
    </AuthShell>
  );
}
